import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { themeEstensa } from '@se/se.platform.base';
import { AgGridModule } from 'ag-grid-angular';
import {
    AllCommunityModule,
    ColDef,
    GridApi,
    GridReadyEvent,
    IRowNode,
    RowSelectionOptions,
    SelectionChangedEvent,
} from 'ag-grid-community';
import { ModalDialogNotificationService } from '../services/notification.service';
import { SeResignModalService } from './se-resign-modal.service';

@Component({
    selector: 'se-resign-modal',
    standalone: true,
    imports: [AgGridModule, MatButtonModule, TranslateModule],
    templateUrl: './se-resign-modal.component.html',
    styleUrl: './se-resign-modal.component.scss',
})
export class SeResignModalComponent implements OnInit {
    @Output() selectedRowsEmitter: EventEmitter<any> = new EventEmitter<any>();
    readonly data = inject<any>(MAT_DIALOG_DATA);
    readonly resignService = inject(SeResignModalService);

    columnsDef: Array<ColDef> = [];
    gridApi!: GridApi;
    gridData: Array<any> = [];
    agGridModuls = [AllCommunityModule];
    agGridTheme = themeEstensa;
    isDisabled: boolean = true;
    rowSelection: RowSelectionOptions = {
        mode: 'multiRow',
        checkboxes: false,
        headerCheckbox: false,
        enableClickSelection: true,
        enableSelectionWithoutKeys: true,
    };
    selectedRows: IRowNode[] = [];
    constructor(
        private modalDialogNotificationService: ModalDialogNotificationService,
        private translate: TranslateService,
    ) {
        if (this.data) {
            this.columnsDef = this.resignService.cdaColumnDefs();
        }
    }

    ngOnInit(): void {
        this.resignService.gridData$.subscribe({
            next: (value) => {
                this.gridData = value;
            },
        });
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
    }

    onSelectionChanged(event: SelectionChangedEvent) {
        this.selectedRows = event.api.getSelectedNodes();
        this.isDisabled = this.selectedRows.length <= 0;
    }

    async sendReportsForCDA() {
        if (this.selectedRows.length > 0) {
            let itemsSelectedData: any[] = [];
            this.selectedRows.forEach((row) => {
                itemsSelectedData.push(row.data);
            });
            this.selectedRowsEmitter.emit(itemsSelectedData);
        } else {
            this.modalDialogNotificationService.info(this.translate.instant('ExamsError'));
        }
    }

    close() {
        this.resignService.close();
    }
}
